import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'

export default function Analytics() {
  const GA_ID = import.meta.env.VITE_GA_ID
  const GTM_ID = import.meta.env.VITE_GTM_ID

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || []
      function gtag(){ window.dataLayer.push(arguments) }
      if (GA_ID) {
        gtag('js', new Date())
        gtag('config', GA_ID)
      }
    }
  }, [GA_ID])

  return (
    <>
      {GA_ID && (
        <Helmet>
          <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}></script>
          <script>
            {`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);}`}
          </script>
        </Helmet>
      )}
      {GTM_ID && (
        <Helmet>
          <script>
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GTM_ID}');`}
          </script>
        </Helmet>
      )}
    </>
  )
}
